'use client';

import Link from '~/shared/components/link';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink } from '~/shared/helpers/browser-helpers';
import type { useTypedTranslation } from '~/shared/hooks';

import type { TopRatedCategoryMenuItem } from '../blog-menu/helpers/blog-menu-cache';

import './all-courses.scss';

import { getUrl } from '~/shared/helpers/string-helpers';

type TopRatedCategoryListItem =
  | TopRatedCategoryMenuItem
  | Readonly<{
      _id: string;
      item: null;
    }>;

type AllCoursesProps = Readonly<{
  lng: Locale;
  error: boolean;
  loading: boolean;
  items: TopRatedCategoryListItem[];
  t: ReturnType<typeof useTypedTranslation>;
}>;

const AllCourses = ({ closeDropdown, lng, t }: AllCoursesProps) => {
  return (
    <nav itemScope itemType="https://schema.org/SiteNavigationElement" className="all-courses">
      <div className="all-courses__links">
        <Link
          className="link--underlined"
          itemProp="url"
          onClick={closeDropdown}
          href={getLocaleLink(
            getUrl({
              link: PAGE_NAMES.COURSES,
            }),
            lng,
          )}
        >
          {t('text.all-paid-courses')}
        </Link>

        <Link
          className="link--underlined"
          itemProp="url"
          onClick={closeDropdown}
          href={getLocaleLink(
            getUrl({
              link: PAGE_NAMES.COURSES,
              getParams: `#free`,
            }),
            lng,
          )}
        >
          {t('text.all-free-courses')}
        </Link>
      </div>
    </nav>
  );
};

export default AllCourses;
